export function setupEditor(editor, getCargoPlanTableHTML) {
  const insertTableCommand = editor.commands.get('insertTable');

  if (!insertTableCommand) return;

  insertTableCommand.on('execute', (evt, args) => {
    evt.stop();

    const options = args?.[0] || {};
    const rows = options.rows || 6;
    const cols = options.columns || 3;

    const html = getCargoPlanTableHTML(rows, cols);

    const view = editor.data.processor.toView(html);
    const model = editor.data.toModel(view);

    editor.model.change(writer => {
      editor.model.insertContent(model);
    });
  }, { priority: 'highest' });
}